import { makeRequest, constructUrlParams } from "../lib/makeRequest";

export const branch_category_overall_v3 = (data) => {
  const params = { from: data.dates.from, to: data.dates.to };
  return makeRequest("/branch-categories/overall", params);
};

export const branch_category_cluster_v3 = (data) => {
  const params = { from: data.dates.from, to: data.dates.to };
  return makeRequest(`/branch-categories/cluster/${data.clusterId}`, params);
};

export const branch_category_area_v3 = (data) => {
  const params = { from: data.dates.from, to: data.dates.to };
  return makeRequest(`/branch-categories/area/${data.areaId}`, params);
};

export const branch_category_branch_v3 = (data) => {
  const urlParams = constructUrlParams(data);
  return makeRequest(
    `/branch-categories/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
